module.exports = __webpack_public_path__ + "img/keyboard_80.0b177687.png";